import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { IconColor, IconSize } from '../icon/icon.component';

type INPUT_TYPES = 'text' | 'email' | 'search' | 'number';
type INPUT_SIZES = 'small' | 'mid' | 'large' | 'xlarge' | 'xxlarge';

@Component({
  selector: 'fl-input',
  template: `
    <div
      class="InputContainer"
      [ngClass]="{ Error: hasError }"
      [attr.data-focus]="attrFocus"
      [attr.disabled]="disabled"
      [attr.data-size]="size"
    >
      <fl-icon *ngIf="iconStart"
        class="IconStart"
        [size]="leftIconSize"
        [color]="leftIconColor"
        [name]="iconStart"
      ></fl-icon>
      <input #nativeElement
        class="NativeElement"
        [attr.type]="type"
        [attr.placeholder]="placeholder"
        [attr.disabled]="attrDisabled"
        [attr.readonly]="attrReadonly"
        [attr.value]="value"
        [formControl]="control"
        (click)="nativeElementOnClick($event)"
        (input)="nativeElementOnInput($event)"
        (focus)="nativeElementOnFocus($event)"
        (blur)="nativeElementOnBlur($event)"
        (keypress)="nativeElementOnKeypress($event)"
      >
      <fl-icon *ngIf="iconEnd"
        class="IconEnd"
        [name]="iconEnd"
      ></fl-icon>
    </div>
  `,
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputComponent {
  attrFocus?: true;
  attrDisabled?: true;
  attrReadonly?: true;
  attrValue?: string;

  @ViewChild('nativeElement') nativeElement: ElementRef;
  @Input() type: INPUT_TYPES = 'text';
  @Input() placeholder?: string;
  @Input()
  set disabled(value: boolean) {
    this.attrDisabled = value ? true : undefined;
  }
  @Input()
  set readonly(value: boolean) {
    this.attrReadonly = value ? true : undefined;
  }
  @Input() size: INPUT_SIZES = 'mid';
  @Input()
  set value(value: string) {
    this.attrValue = value;
  }
  get value() {
    return this.nativeElement.nativeElement.value;
  }
  @Input() iconStart: string;
  @Input() iconEnd: string;
  @Input() leftIconSize? = 'mid' as IconSize;
  @Input() leftIconColor? = 'inherit' as IconColor;
  @Input() hasError = false;

  // We need a default value to FormControl so an input can
  // still work without a FormControl specified.
  // If only we have object props spreading or FormControl
  // accepts undefined and just removes the assignment...
  @Input() control: FormControl = new FormControl();
  @Output() input = new EventEmitter<InputEvent>();
  @Output() click = new EventEmitter<MouseEvent>();
  @Output() focus = new EventEmitter<FocusEvent>();
  @Output() blur = new EventEmitter<FocusEvent>();
  @Output() keypress = new EventEmitter<KeyboardEvent>();

  nativeElementOnFocus(event: FocusEvent) {
    this.attrFocus = true;
    this.focus.emit(event);
  }

  nativeElementOnBlur(event: FocusEvent) {
    this.attrFocus = undefined;
    this.blur.emit(event);
  }

  nativeElementOnInput(event: InputEvent) {
    this.input.emit(event);
  }

  nativeElementOnClick(event: MouseEvent) {
    this.click.emit(event);
  }

  nativeElementOnKeypress(event: KeyboardEvent) {
    this.keypress.emit(event);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/app/@shared/ui/input/input.component.ts